import type { MinifiedTask, TaskCategory } from '@gcv/shared';

import type { GetAssigneesParams } from '../../tasks/components/tasks-modal.repo';
import { COMMENT_TASK_TYPES } from '../../tasks/util';

/** Which users and groups a single task may be reassigned to. */
export const getTaskAssigneeParams = (
  task: MinifiedTask | undefined,
  taskCategory: TaskCategory | undefined,
  isExternal: boolean
): GetAssigneesParams => ({
  orgId: isExternal ? task?.assigned_org?.id ?? '' : '',
  taskCategory: task?.task_category ?? taskCategory,
  originalGroupIds: [
    ...new Set([...(task?.assigned_group_ids ?? []), ...(task?.original_assigned_group_ids ?? [])])
  ],
  originalUserIds: task?.original_assigned_user_ids ?? task?.assigned_users?.map((u) => u.id!) ?? [],
  isExternal,
  isCommentTask: COMMENT_TASK_TYPES.includes(task?.internal_type)
});
